<template>
<br />
  <div class="col-md-4 justify-content-center">
    <div class="">
<br />

      <Form @submit="handleLogin" :validation-schema="schema">
        <div class="form-group">
          <label for="nif">Codi centre</label>
          <Field name="nif" type="text" class="form-control" value="" />
          <ErrorMessage name="nif" class="error-feedback" />
        </div>
        <div class="form-group">
          <label for="password">Contrasenya</label>
          <Field name="password" type="password" class="form-control" value="" />
          <ErrorMessage name="password" class="error-feedback" />
        </div>

        <div class="form-group">
          <button class="btn btn-primary btn-block" :disabled="loading">
            <span
              v-show="loading"
              class="spinner-border spinner-border-sm"
            ></span>
            <span>Entrar</span>
          </button>
        </div>

        <div class="form-group">
          <div v-if="message" class="alert alert-danger" role="alert">
            {{ message }}
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";

export default {
  name: "Login",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    const schema = yup.object().shape({
      nif: yup.string().required("NIF is required!"),
      password: yup.string().required("Password is required!"),
    });

    return {
      loading: false,
      message: "",
      schema,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  created() {
    if (this.loggedIn) {
      this.$router.push("/");
    }
  },
  methods: {
    handleLogin(user) {
      this.loading = true;

      this.$store.dispatch("auth/login", user).then(
        () => {
          this.$router.push("/");
        },
        () => {
          this.loading = false;
          this.message = "Error en iniciar sessió: l’usuari o la contrasenya no són vàlids."
        }
      );
    },
  },
};
</script>

<style scoped>

</style>